import { z } from "zod";

import { zCmpOp } from "../../../../../types/ZCmpOp";

export const zRuleRequired = z.object({
  type: z.literal("required"),
  msg: z.string().nullish(),
});
export type ZRuleRequired = z.infer<typeof zRuleRequired>;

export const zRulePattern = z.object({
  type: z.literal("pattern"),
  pattern: z.string().describe("Строковое представление регулярного выражения"),
  msg: z.string().nullish(),
});
export type ZRulePattern = z.infer<typeof zRulePattern>;

// Предполагается, что значение поле должно быть больше или равно minValue. Это частный случай правила сравнения.
export const zRuleMin = z.object({
  type: z.literal("min"),
  minValue: z.string().or(z.number()),
  msg: z.string().nullish(),
});

export const zRuleCmpField = z.object({
  type: z.literal("cmpField"),
  op: zCmpOp,
  path: z.string(),
  msg: z.string().nullish(),
});

export const zRule = z.discriminatedUnion("type", [
  zRuleRequired,
  zRulePattern,
  zRuleMin,
  zRuleCmpField,
]);
export type ZRule = z.infer<typeof zRule>;
